import ImageOne from "../images/interior-1.jpg";
import ImageTwo from "../images/house-5.jpg";

export const InfoData = {
  heading: "Explore our beautiful homes",
  paragraphOne:
    "Enjoy the spectacular natural setting of these modern, hillside properties in the desirable Mesa neighborhood known as a zone with great walkability. These modern retreats are simply magical with its magnificent, established landscape and gorgeous outcroppings of rock formations set against the stark white mid-century styling of the home. Experience a relaxed and comfortable modern living environment with a level in/out, open floor plan perfect for seamless indoor/outdoor Palm Springs living. ",
  paragraphTwo: "Nearby: Joshua Tree national Monument, Cabazon Outlet Mall",
  buttonLabel: "View Homes",
  image: ImageOne,
  reverse: false,
  delay: 100,
};

export const InfoDataTwo = {
  heading: "Modern Designs",
  paragraphOne:
    "Using only the highest quality materials and furniture, our team then provides finish palettes, 2D plans, and idea boards. This is where clients will be inspired by our team’s creativity. .",
  paragraphTwo:
    "Once we collaborate with the client to refine the vision of the home design project, our team will then bring the design to life with a 3D rendering of the environment",
  buttonLabel: "View Homes",
  image: ImageTwo,
  reverse: true,
  delay: 300,
};
